import { useEffect, useState } from "react";
import { FaPhoneAlt, FaRegClock, FaSearch } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { FaRegCalendar } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import { BiGasPump } from "react-icons/bi";
import { LuMessageCircle } from "react-icons/lu";
import { FaCarAlt } from "react-icons/fa";
import { FaGear, FaLocationDot } from "react-icons/fa6";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FiltrosAvancados from "../components/FiltrosAvancados";
import BannerCarousel from "../components/BannersCarousel";
import { formatMoney } from "../utils/formatMoney";
import { Card, CardContent } from "../components/ui/Card";
import { FiShoppingCart as ShoppingCart, FiCreditCard as CreditCard } from "react-icons/fi";
import { FaAward as Award, FaUsers as Users } from "react-icons/fa";

const firestore = getFirestore(app);

export default function Home() {
  const [veiculos, setVeiculos] = useState([]);
  const [revenda, setRevenda] = useState({});
  const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
  const [filtrosAvancados, setFiltrosAvancados] = useState({
    tipo: "",
    cor: "",
    portas: "",
    kmMax: "",
    precoMin: "",
    precoMax: "",
  });
  const [, setErroFiltro] = useState("");

  const navigate = useNavigate();



  useEffect(() => {
    window.scrollTo(0, 0);

    const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
    getDoc(revendaRef).then((docSnap) => {
      if (docSnap.exists()) {
        setRevenda(docSnap.data());
      }
    });

    const q = query(
      collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
      where("veremovido", "==", 0),
      where("vevendido", "==", 0),
      orderBy("updated_at", "desc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        const document = doc.data();
        document.id = doc.id;
        if (document["veexibir_site"] !== false) {
          items.push(document);
        }
      });
      setVeiculos(items);
    });

    return () => unsubscribe();
  }, []);

  function getOpcoesFiltro(campo, marcaSelecionada = "") {
    const modelosFiltrados = veiculos.filter((veiculo) => {
      if (campo === "vefipe_name" && marcaSelecionada) {
        return veiculo.vefipe_marca === marcaSelecionada;
      }
      return true;
    });

    const opcoes = modelosFiltrados
      .map((veiculo) => veiculo[campo])
      .filter((valor, index, self) => valor && self.indexOf(valor) === index);

    return opcoes.sort();
  }

  const handleBuscar = () => {
    if (
      !filtros.marca &&
      !filtros.modelo &&
      !filtros.ano &&
      !Object.values(filtrosAvancados).some((value) => value)
    ) {
      setErroFiltro("Selecione pelo menos um filtro.");
      return;
    }

    const params = new URLSearchParams();
    // Mapeia os nomes dos filtros para os nomes dos campos do veículo
    if (filtros.marca) params.append("vefipe_marca", filtros.marca);
    if (filtros.modelo) params.append("vefipe_name", filtros.modelo);
    if (filtros.ano) params.append("vefipe_ano_modelo", filtros.ano);

    Object.entries(filtrosAvancados).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    setErroFiltro("");
    navigate(`/estoque?${params.toString()}`);
  };

  function separarNomeVeiculo(nomeCompleto) {
    if (!nomeCompleto) return { mainName: '', subName: '' };

    const palavras = nomeCompleto.split(' ');

    const STOP_WORDS = [
      'CD', 'SR', 'SRV', 'GR', 'XEI', 'LTZ', 'LX',
      '4X4', '4X2',
      '1.0', '1.2', '1.3', '1.4', '1.5', '1.8', '1.6', '2.0', '2.8',
      'TDI', 'TURBO', 'DIESEL', 'FLEX',
      'AUT', 'AUT.', 'MT', 'CVT'
    ];

    const indexSpec = palavras.findIndex(p =>
      STOP_WORDS.includes(p)
    );

    if (indexSpec === -1) {
      return {
        mainName: palavras.slice(0, 2).join(' '),
        subName: palavras.slice(2).join(' ')
      };
    }

    return {
      mainName: palavras.slice(0, indexSpec).join(' '),
      subName: palavras.slice(indexSpec).join(' ')
    };
  }

  console.log(veiculos)

  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <div className="flex flex-col items-center text-center sm:mt-12 space-y-2">
        <BannerCarousel />

        <div className="relative flex flex-col items-center justify-center text-black text-center px-2 sm:px-4">
          <h1 className="text-3xl sm:text-4xl md:text-6xl mt-8 font-bold mb-2 sm:mb-4">Carros em <span className="text-red-700">Destaque</span>
          </h1>
          <p className="text-gray-400 sm:text-lg md:text-xl mb-4 sm:mb-8">
            Confira nossa seleção de veículos premium disponíveis para você
          </p>

          {/*<div className="bg-white rounded-xl flex flex-col gap-2 md:gap-4 p-3 sm:p-6 shadow-lg w-full max-w-lg sm:max-w-2xl md:max-w-3xl">
            <div className="flex flex-col items-center md:flex-row gap-2 md:gap-4">
              <select
                className="p-2 rounded-md border border-gray-300 text-black w-full md:w-1/3"
                value={filtros.marca}
                onChange={e => {
                  setFiltros(f => ({ ...f, marca: e.target.value }));
                  setErroFiltro("");
                }}
              >
                <option value="">Marca</option>
                {getOpcoesFiltro("vefipe_marca").map(marca => (
                  <option key={marca} value={marca}>{marca}</option>
                ))}
              </select>

              <div className="relative w-full md:w-1/3">
                <select
                  className="p-2 rounded-md border border-gray-300 text-black w-full"
                  value={filtros.modelo}
                  onChange={e => setFiltros(f => ({ ...f, modelo: e.target.value, ano: "" }))}
                >
                  <option value="">Modelo</option>
                  {getOpcoesFiltro("vefipe_name", filtros.marca)
                    .map(modelo => (
                      <option key={modelo} value={modelo}>{modelo}</option>
                    ))}
                </select>
              </div>

              <div className="relative w-full md:w-1/3">
                <select
                  className="p-2 rounded-md border border-gray-300 text-black w-full"
                  value={filtros.ano}
                  onChange={e => {
                    setFiltros(f => ({ ...f, marca: e.target.value, modelo: "", ano: "" }));
                    setErroFiltro("");
                  }}
                >
                  <option value="">Ano</option>
                  {getOpcoesFiltro("vefipe_ano_modelo")
                    .map(ano => (
                      <option key={ano} value={ano}>{ano}</option>
                    ))}
                </select>
              </div>

              <div className="flex flex-col sm:flex-row gap-2 mt-2">
                {(filtros.marca || filtros.modelo || filtros.ano) && (
                  <button
                    className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md font-semibold whitespace-nowrap w-full sm:w-auto"
                    type="button"
                    onClick={() => {
                      setFiltros({ marca: "", modelo: "", ano: "" });
                      setErroFiltro("");
                    }}
                  >
                    Limpar filtros
                  </button>
                )}

                <button
                  className="flex items-center justify-center gap-2 bg-zinc-700 text-white px-4 py-2 rounded-md w-full sm:w-auto"
                  onClick={handleBuscar}
                  type="button"
                >
                  <FaSearch /> Buscar
                </button>
              </div>
            </div>

            <div className="flex justify-center mt-4">
              <div className="w-full">
                <FiltrosAvancados
                  filtros={filtrosAvancados}
                  setFiltros={setFiltrosAvancados}
                />
              </div>
            </div>
          </div>*/}
        </div>
      </div>


      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-6 max-w-6xl mx-auto px-4">
        {veiculos
          .slice()
          .sort(() => Math.random() - 0.5)
          .slice(0, 3)
          .map((veiculo) => {

            const { mainName, subName } = separarNomeVeiculo(
              veiculo.vefipe_name
            );

            const cambio = veiculo.vecambio === 'A' ? 'Automático' : veiculo.vecambio === 'M' ? 'Manual' : veiculo.vecambio;

            veiculo.vecambio = cambio;

            return (
              <div key={veiculo.id} className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-[110%]">
                <img className="object-contain w-full h-48 md:h-64 lg:h-72" src={veiculo.imagens[0]?.fileUrl} alt={veiculo.titulo} />

                <div className="p-4 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-lg font-bold uppercase">
                      {veiculo.vefipe_marca} {mainName}
                    </h3>

                    {subName && (
                      <p className="text-sm text-gray-400 uppercase">
                        {subName}
                      </p>
                    )}
                  </div>

                  <div className="grid grid-cols-2 text-gray-500 space-y-2 text-sm">
                    <span className="flex items-center gap-1">
                      <MdSpeed /> {veiculo.vequilometragem}km
                    </span>
                    <span className="flex items-center gap-1">
                      <BiGasPump /> {veiculo.vefipe_combustivel}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaRegCalendar /> {veiculo.veano_fabricacao} / {veiculo.vefipe_ano_modelo}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaGear /> {veiculo.vecambio}
                    </span>
                  </div>

                  <hr className="text-gray-600" />
                  <div className="mt-2 flex gap-4 items-center justify-between">
                    <p className="text-xl font-bold text-black">
                      {veiculo.vevalor
                        ? formatMoney(veiculo.vevalor)
                        : 'Consulte o preço'}
                    </p>


                    <a
                      href={`/veiculo/${veiculo.id}`}
                      className="bg-zinc-600 text-white px-4 py-2 rounded flex gap-2 items-center"
                    >
                      <FiEye /> Ver Detalhes
                    </a>

                  </div>
                </div>
              </div>
            );
          })}

      </div>

      <div className="text-center mt-20 ">
        <a
          className="bg-[#B91C1C] text-white px-6 py-3 rounded-md text-lg font-semibold inline-flex gap-2 items-center"
          href="/estoque"
        >
          <FaCarAlt /> Ver Todo o Estoque
        </a>
      </div>

      {/* Services Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-balance">Por Que Escolher a Primos-Car?</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300 h-[350px]">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-zinc-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <ShoppingCart className="text-zinc-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3">Compra e Venda</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Processo rápido e transparente para comprar ou vender seu veículo
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-zinc-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CreditCard className="text-zinc-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3">Financiamento Facilitado</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Condições especiais e aprovação rápida para realizar seu sonho
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-zinc-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="text-zinc-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3">Avaliação Justa</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Avaliamos seu veículo com o melhor preço do mercado
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-zinc-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="text-zinc-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3">Atendimento Personalizado</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Equipe especializada pronta para te ajudar em cada etapa
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>



      {/* Seção de contato + mapa */}
      {/*<section className="py-8 sm:py-12 px-2 sm:px-4 md:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-center text-neutral-700 mt-10 sm:mt-20">Visite Nossa Loja</h2>
          <p className="text-center text-gray-700 text-base sm:text-xl mt-2 mb-6 sm:mb-10">
            Uma experiência completa para você encontrar o carro ideal
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-start">
            <div className="space-y-4 sm:space-y-6">
              <h3 className="text-lg sm:text-xl font-semibold text-neutral-700">Entre em Contato</h3>

              <div className="flex items-center gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-zinc-600 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <FaPhoneAlt />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">Telefone</p>
                  <p className="text-[#003c85] font-semibold">{retiraMascara(revenda.petelefone1)}</p>
                </div>
              </div>

              <div className="flex items-center gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-zinc-600 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <LuMessageCircle />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">WhatsApp</p>
                  <p className="text-[#003c85] font-semibold">{retiraMascara(revenda.petelefone2)}</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-zinc-600 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <FaLocationDot />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">Endereço</p>
                  <p className="text-neutral-600">
                    {revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} – {revenda.pebairro_fiscal}
                  </p>
                  <p className="text-neutral-600">{revenda.pecidade} – {revenda.peuf}</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-zinc-600 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <FaRegClock />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">Horário</p>
                  <p className="text-neutral-600">Segunda à Sexta: 8:00 às 18:00</p>
                  <p className="text-neutral-600">Sábado: 8:00 às 12:00</p>
                </div>
              </div>
            </div>

            <div>
              <iframe
                className="w-full h-64 sm:h-[400px] rounded-xl shadow-md"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.4697863907577!2d-46.5146187!3d-18.5979279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94aef534dd6ce9a5%3A0x43a50817fdb9d433!2sIbiza%20Ve%C3%ADculos!5e0!3m2!1spt-BR!2sbr!4v1751310841918!5m2!1spt-BR!2sbr"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa da Loja"
              ></iframe>
            </div>
          </div>
        </div>
      </section>*/}

      <Footer />
    </div>
  );
}
